if (!customElements.get('lineitem-price')) {
    class LineitemPrice extends ErpConnection {

        constructor() {
            super();
            
            this.propertyElement = this.querySelector("input[name='properties[_price]']");
            this.propertyBegoElement = this.querySelector("input[name='properties[_bego_price]']");
            this.propertyFullPrice = this.querySelector("input[name='properties[_fullprice]']");
            this.propertyDiscPrice = this.querySelector("input[name='properties[_disc]']");
            this.propertyDiscpctPrice = this.querySelector("input[name='properties[_discpct]']");
            this.submitButton = this.querySelector("button[type='submit']");
            
            fetch(this.ENDPOINT + "/price?" + new URLSearchParams({
                item_id: this.dataset.item_id,
                company: this.dataset.company,
                account_id: document.body.dataset.customer_account_id
            }), {
                method: "GET",
                headers: this.HEADER.GET
            }).then(res => {
                if (res.status == 200) {
                    return res.json();
                }
            }).then(body => {

              /*console.log("body"+JSON.stringify(body));*/
                if (body.amount != undefined && body.amount != null) {
                  /*console.log("body.amount :: "+body.amount);*/
                    this.propertyElement.value = Math.round(parseFloat(body.amount) * 100);
                    this.propertyBegoElement.value = Math.round(parseFloat(body.amount) * 100);
                    this.submitButton.disabled = false;
                }
                if (body.fullAmount && body.fullAmount != '') {
                    this.propertyFullPrice.value = Math.round(parseFloat(body.fullAmount) * 100);
                }
                if (body.disc && body.disc != '') {
                    this.propertyDiscPrice.value = Math.round(parseFloat(body.disc) * 100);
                }
                if (body.discPct && body.discPct != '') {
                    this.propertyDiscpctPrice.value = Math.round(parseFloat(body.discPct) * 100);
                }
            }).catch(err => {
                console.error("ERROR:" , err);
            });
        }
    }
    customElements.define('lineitem-price', LineitemPrice);
}